export const SET_ORGANIZATIONS = 'SET_ORGANIZATIONS'
export const SET_ORGANIZATION = 'SET_ORGANIZATION'
export const SET_CHECKED = 'SET_CHECKED'
export const ADD_ORGANIZATION = 'ADD_ORGANIZATION'
export const UPDATE_ORGANIZATION = 'UPDATE_ORGANIZATION'
export const SET_FOUND_ORGANIZATIONS = 'SET_FOUND_ORGANIZATIONS'
export const SET_PAGER = 'SET_PAGER'
export const SET_ORGANIZATION_DATA = 'SET_ORGANIZATION_DATA'
export const RESET_ORGANIZATION = 'RESET_ORGANIZATION'
export const EXAMINE_ORGANIZATION = 'EXAMINE_ORGANIZATION'
export const SET_MEMBERS = 'SET_MEMBERS'
export const SET_FOUND_MEMBERS = 'SET_FOUND_MEMBERS'
export const SORT_MEMBERS = 'SORT_MEMBERS'
export const SET_LIBRARYNAME = 'SET_LIBRARYNAME'
export const SET_CHALLENGENAME = 'SET_CHALLENGENAME'
export const SET_DASHBOARDNAME = 'SET_DASHBOARDNAME'
export const SET_TAGS = 'SET_TAGS'

export const STORE_PAGER = 'organization/pager'
export const STORE_EXAMINE_ORG = 'organization/examine'
